(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-compare-tabs"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function($) {
    setTimeout(function() {
       $('.tabs-horizontal li:first-child').trigger('click');
    }, 30000);
  });
  $('.tabs-horizontal li').on('click', function() {
    $('.beforeafter-carousel').owlCarousel('destroy');
    $('.beforeafter-carousel').removeClass("owl-carousel");
    
          $('.tabs-horizontal li').removeClass('active');
          $('.tabs.content li.tab_content').removeClass('active');
          $(this).addClass('active');
          $('.tabs.content li.tab_content').eq($(this).index()).addClass('active');
          $('.beforeafter-carousel').owlCarousel({
              items:3,
              loop:true,
              dots: true,
              margin:10,
              touchDrag: false,
              mouseDrag: false,
              pullDrag: false,
              navigation: true,
              responsive:{
                  0:{
                      items:1
                  },
                  768:{
                      items:3
                  }
              }
          });
          
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["imagetext-tabs"] && !window.DesignMode) return;
  try {
    
    HorizontalTabs = (function() {
    function HorizontalTabs() {
      $('.tabs-horizontal.headings').each(function() {
        return $(this).add($(this).next('.tabs.content')).wrapAll("<div class='tabs-wrapper horizontal'/>");
      });
      $('.tabs-horizontal.headings li').wrapInner('<div class="trigger"></div>');
      $('.tabs-horizontal.headings li .trigger').append('<div class="bg"></div>');
      $('.tabs-wrapper.horizontal').each(function() {
        var tab_content, tab_headings;
        tab_headings = $(this).find('.headings > li');
        tab_content = $(this).find('.tabs.content > li');
        tab_content.first().addClass('active');
        tab_headings.first().addClass('active');
        return tab_headings.on('click', function() {
          tab_headings.removeClass('active');
          tab_content.removeClass('active');
          $(this).addClass('active');
          return tab_content.eq($(this).index()).addClass('active');
        });
      });
    }

    return HorizontalTabs;

  })();

  $('.headings li').on('click', function() {
          $('.headings li').removeClass('active');
          $('.tabs.content li').removeClass('active');
          $(this).addClass('active');
          $('.tabs.content li').eq($(this).index()).addClass('active');
  });
  

  } catch(e) { console.error(e); }
})();
})();
